"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../config"));

var _utils = require("../../utils");

var iconClassNames = {
  "icon": "icon-icon-35iz-"
};

var resolve = function resolve(url) {
  return _config.default.iconsPublicPath != null && url && url.toString().charAt() === '#' ? "" + _config.default.iconsPublicPath + url : url;
};
/**
 * The component creates an inline SVG image based on
 * `src` and `alt` attributes.
 */


var Icon = function Icon(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      className = _ref.className,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["src", "alt", "className"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    className: _utils.classNames.use(iconClassNames.icon).join(className),
    role: "img"
  }, restProps), _react.default.createElement("title", null, alt), _react.default.createElement("use", {
    href: resolve(src)
  }));
};

Icon.propTypes = {
  /**
   * Icon location
   *
   * It can be either an icon reference to a sprite, e.g. `#alert`
   * or full icon path for any other icon.
   */
  src: _propTypes.default.string.isRequired,

  /**
   * Alternative text for accessibility
   */
  alt: _propTypes.default.string.isRequired
};
var _default = Icon;
exports.default = _default;